// Copyright (C) 2021 TANNER AG

import React from "react";
import { compose } from "recompose";
import { withStyles } from "@material-ui/core/styles";
import { sharedComponentStyles } from "../screens/Component";
import buildAssetUrl from "../utils/buildAssetUrl";

const styles = (theme) => ({
    imageStyle: {
        maxWidth: "100%",
        height: "auto",
    },
});

const EMobilityContentImage = ({ classes, image }) => {
    if (!image) {
        return null;
    }

    let imageUrl;
    if (image) {
        const { url } = buildAssetUrl(image, 400);
        imageUrl = url;
    }

    return (
        <React.Fragment>
            {imageUrl && <img className={classes.imageStyle} alt="2-column" src={imageUrl} />}
        </React.Fragment>
    );
};

export default compose(withStyles(sharedComponentStyles), withStyles(styles))(EMobilityContentImage);



// WEBPACK FOOTER //
// ./src/emobility/EMobilityContentImage.js